'use strict';

var _regeneratorRuntime = require("/workspace/node_modules/@babel/runtime/regenerator/index.js");

var _defineProperty = require("/workspace/node_modules/@babel/runtime/helpers/defineProperty.js");

var _asyncToGenerator = require("/workspace/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var pageResults = require('graph-results-pager');

var _require = require('bluebird'),
    Promise = _require.Promise;

var _require2 = require('./constants'),
    graphAPIEndpoints = _require2.graphAPIEndpoints;

var sushi = require('./queries/sushi');

var blocks = require('./queries/blocks');

var charts = require('./queries/charts');

var exchange = require('./queries/exchange');

var exchange_v1 = require('./queries/exchange_v1');

var masterchef = require('./queries/masterchef');

var bar = require('./queries/bar');

var maker = require('./queries/maker');

var timelock = require('./queries/timelock');

var lockup = require('./queries/lockup');

var bentobox = require('./queries/bentobox');

var utils = require('./utils');

module.exports = {
  pageResults: pageResults,
  graphAPIEndpoints: graphAPIEndpoints,
  sushi: sushi,
  blocks: blocks,
  charts: charts,
  exchange: exchange,
  exchange_v1: exchange_v1,
  masterchef: masterchef,
  bar: bar,
  maker: maker,
  timelock: timelock,
  lockup: lockup,
  bentobox: bentobox,
  utils: utils,
  timeseries: function timeseries() {
    var _arguments = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _ref, _ref$blocks, blocks, _ref$timestamps, timestamps, _ref$target, target, targetArguments;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _ref = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {}, _ref$blocks = _ref.blocks, blocks = _ref$blocks === void 0 ? undefined : _ref$blocks, _ref$timestamps = _ref.timestamps, timestamps = _ref$timestamps === void 0 ? undefined : _ref$timestamps, _ref$target = _ref.target, target = _ref$target === void 0 ? undefined : _ref$target;
              targetArguments = _arguments.length > 1 ? _arguments[1] : undefined;

              if (target) {
                _context3.next = 4;
                break;
              }

              throw new Error("sushi-data: Target function undefined");

            case 4:
              if (!(!blocks && !timestamps)) {
                _context3.next = 6;
                break;
              }

              throw new Error("sushi-data: Timeframe undefined");

            case 6:
              if (!blocks) {
                _context3.next = 10;
                break;
              }

              return _context3.abrupt("return", Promise.map(blocks, /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(block) {
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.t0 = block;
                          _context.next = 3;
                          return target(_objectSpread({
                            block: block
                          }, targetArguments));

                        case 3:
                          _context.t1 = _context.sent;
                          return _context.abrupt("return", {
                            block: _context.t0,
                            data: _context.t1
                          });

                        case 5:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }()));

            case 10:
              return _context3.abrupt("return", Promise.map(timestamps, /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(timestamp) {
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.t0 = timestamp;
                          _context2.next = 3;
                          return target(_objectSpread({
                            timestamp: timestamp
                          }, targetArguments));

                        case 3:
                          _context2.t1 = _context2.sent;
                          return _context2.abrupt("return", {
                            timestamp: _context2.t0,
                            data: _context2.t1
                          });

                        case 5:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x2) {
                  return _ref3.apply(this, arguments);
                };
              }()));

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
};